// extracted by mini-css-extract-plugin
export default {"wrapper":"PageNotFound_wrapper__VETDo","title":"PageNotFound_title__8olfF","errorCode":"PageNotFound_errorCode__sryv1"};